module.exports = __webpack_public_path__ + "img/img6.731d5bbd.png";